import { combineReducers } from 'redux';

import auth from './auth/reducer';
import legacyUser from './legacyUser/reducer';
import legacyUserStatus from './legacyUserStatus/reducer';
import legacyUserProfile from './legacyUserProfile/reducer';
import legacyOrders from './legacyOrders/reducer';
import legacyEvaluations from './legacyEvaluations/reducer';
import products from './products/reducer';
import notifications from './notifications/reducer';
import invitations from './invitations/reducer';
import userStatus from './userStatus/reducer';
import promotions from './promotions/reducer';
import router from './router/reducer';
import orders from './orders/reducer';
import loading from './loading/reducer';

const rootReducer = combineReducers({
  auth,
  products,
  notifications,
  invitations,
  legacyUser,
  legacyUserStatus,
  legacyUserProfile,
  legacyOrders,
  legacyEvaluations,
  userStatus,
  promotions,
  router,
  orders,
  loading,
});

export default rootReducer;
